import React from "react";
import { Header } from "../components/Header";
import { HeroVariant } from "../components/HeroVariant";
import { AboutSection } from "../components/AboutSection";
import { SpeakersSectionBlack } from "../components/SpeakersSectionBlack";
import { ExperienceSectionBlack } from "../components/ExperienceSectionBlack";
import { EventFormatSection } from "../components/EventFormatSection";
import { ImpactSection } from "../components/ImpactSection";
import { SponsorsSection } from "../components/SponsorsSection";
import { Footer } from "../components/Footer";

export default function DesignC() {
  return (
    <div className="theme-black min-h-screen" style={{ background: "#ffffff", fontFamily: "'Inter', Arial, sans-serif" }}>
      <Header />
      <main>
        <HeroVariant bgImage="/white-gradient-1.avif" darkOverlay={false} accentColor="#000000" />
        <AboutSection />
        <SpeakersSectionBlack />
        <ExperienceSectionBlack />
        <EventFormatSection />
        <ImpactSection />
        <SponsorsSection />
      </main>
      <Footer />
    </div>
  );
}
